<div class="warehouse-section">

  <!-- Existing entries -->
  <table class="table table-compact" *ngIf="warehouse.length > 0">
    <thead>
      <tr>
        <th class="left">Art</th>
        <th class="left">Datum</th>
        <th class="left">Lieferschein</th>
        <th class="left">Zeichnungsnummer</th>
        <th class="right">Anzahl</th>
        <th class="left">Seriennummer</th>
        <th class="left">Charge</th>
        <th class="left">Erfasst von</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let w of warehouse">
        <td class="left">
          <span [ngClass]="movementClass(w.movement_type)">{{ movementLabel(w.movement_type) }}</span>
        </td>
        <td class="left">{{ w.date | date:'dd.MM.yyyy' }}</td>
        <td class="left">
          <button *ngIf="w.file_id" class="btn btn-sm btn-link" (click)="showModal(w.file_id, w.file_description)"><cds-icon shape="file"></cds-icon> {{ w.file_description || 'Dokument' }}</button>
          <a *ngIf="!w.file_id && w.transport_id > 0" class="btn btn-sm btn-link" [routerLink]="['/transport/details', w.project_id, w.job_id, w.transport_id, w.order_id]"><cds-icon shape="truck"></cds-icon> Transport {{ w.project_id }}.0005.{{ w.transport_id }}</a>
          <span *ngIf="!w.file_id && !(w.transport_id > 0)">—</span>
        </td>
        <td class="left">{{ w.technical_drawing || '—' }}</td>
        <td class="right">
          <b [ngClass]="pieceClass(w.movement_type)">{{ pieceSign(w.movement_type) }}{{ w.number_of_pieces }}</b>
        </td>
        <td class="left">{{ w.serial_nr || '—' }}</td>
        <td class="left">{{ w.heat_nr || '—' }}</td>
        <td class="left">{{ w.firstname }} {{ w.lastname }}</td>
        <td class="action-cell">
          <cds-icon shape="times-circle" class="is-solid icon-delete" (click)="deleteFromWarehouse(w.id)"></cds-icon>
        </td>
      </tr>
    </tbody>
  </table>

  <p *ngIf="!loading && warehouse.length === 0" class="empty-hint">Noch keine Lagerbewegungen für diese Position.</p>

  <!-- New entry form -->
  <div class="warehouse-form" *ngIf="editPos > 0">
    <form [formGroup]="warehouseForm" class="clr-form clr-form-compact">
      <div class="form-row">

        <clr-select-container>
          <label>Art der Bewegung</label>
          <select clrSelect formControlName="movement_type">
            <option value="incoming">Wareneingang</option>
            <option value="outgoing">Warenausgang</option>
            <option value="return_inbound">Rückgabe Eingang</option>
            <option value="return_outbound">Rückgabe Ausgang</option>
            <option value="internal_transfer">Interne Umbuchung</option>
            <option value="scrap">Ausschuss</option>
          </select>
        </clr-select-container>

        <div class="form-group">
          <label>Wareneingangsschein hochladen</label>
          <div class="upload-row">
            <label class="btn btn-sm btn-outline" for="wes-upload">
              <cds-icon shape="upload"></cds-icon> Datei wählen
            </label>
            <input id="wes-upload" type="file" accept=".pdf,.jpg,.jpeg,.png" style="display:none" (change)="onFileSelected($event)" />
            <span class="upload-filename">{{ selectedFile ? selectedFile.name : '— keine Datei —' }}</span>
          </div>
        </div>

        <clr-date-container>
          <label>Datum</label>
          <input type="date" clrDate formControlName="date" />
        </clr-date-container>

        <clr-input-container>
          <label>Anzahl</label>
          <input type="number" clrInput min="0" formControlName="number_of_pieces" />
        </clr-input-container>

        <clr-input-container>
          <label>Seriennummer</label>
          <input type="text" clrInput placeholder="optional" formControlName="serial_nr" />
        </clr-input-container>

        <clr-input-container>
          <label>Charge</label>
          <input type="text" clrInput placeholder="optional" formControlName="heat_nr" />
        </clr-input-container>

      </div>
    </form>
  </div>

  <!-- Actions -->
  <div class="warehouse-actions">
    <button *ngIf="editPos === 0" class="btn btn-sm btn-primary" (click)="editPos = 1">
      <cds-icon shape="plus-circle"></cds-icon> Lieferung erfassen
    </button>
    <ng-container *ngIf="editPos > 0">
      <button class="btn btn-sm btn-success" (click)="addToWarehouse()" [disabled]="uploading">
        <cds-icon shape="check-circle"></cds-icon> {{ uploading ? 'Wird hochgeladen…' : 'Lieferung speichern' }}
      </button>
      <button class="btn btn-sm btn-link" (click)="editPos = 0">Abbrechen</button>
    </ng-container>
  </div>

</div>

<!-- PDF Modal -->
<clr-modal *ngIf="showPdf" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
  <h3 class="modal-title">{{ modalContent }}</h3>
  <div class="modal-body">
    <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
  </div>
</clr-modal>
